import script from "./ViabilityMapControls.vue?vue&type=script&setup=true&lang=js"
export * from "./ViabilityMapControls.vue?vue&type=script&setup=true&lang=js"

import "./ViabilityMapControls.vue?vue&type=style&index=0&id=86e3d510&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86e3d510"]])

export default __exports__